import {useQuery} from 'react-query';
import {getIsAlternativeRelatedItemsModelTestEnabled} from '../../utils/alternativeRelatedItemsModelTest';

const isK8s = process.env.K8S_DEPLOYMENT === 'true';
const recoApiUrl = () => {
  if (isK8s) {
    return __ENV__ === 'production'
      ? process.env.RECO_API_URL_PROD
      : process.env.RECO_API_URL_STAGING;
  }
  return process.env.RECO_API_URL;
};

const fetchRecommendedStyles = async ({colorId, limit = 4, styleId}) => {
  const queryParams = new URLSearchParams();
  if (colorId) {
    queryParams.append('colorId', colorId);
  }
  if (limit) {
    queryParams.append('limit', limit);
  }

  const isAlternativeRelatedModelTestEnabled =
    getIsAlternativeRelatedItemsModelTestEnabled();

  const relatedProductsEndpointUrl = isAlternativeRelatedModelTestEnabled
    ? `${recoApiUrl()}/api/v1/related-products/${styleId}/alternative${queryParams ? `?${queryParams}` : ''}`
    : `${recoApiUrl()}/api/v1/related-products/${styleId}${queryParams ? `?${queryParams}` : ''}`;

  const response = await fetch(relatedProductsEndpointUrl);
  if (!response.ok) {
    throw new Error('Failed to fetch recommended styles', {
      response,
      styleId
    });
  }
  return response.json();
};

const useRecommendedStyles = (styleId, options = {}) => {
  const {colorId, limit = 4} = options?.queryParams || {};
  return useQuery({
    queryFn: () =>
      fetchRecommendedStyles({
        colorId,
        limit,
        styleId
      }),
    queryKey: ['recommendations', styleId, colorId, limit],
    ...options
  });
};

const fetchPromotionalProducts = async ({categoryId, limit = 6}) => {
  const queryParams = new URLSearchParams();
  if (categoryId) {
    queryParams.append('categoryId', categoryId);
  }
  if (limit) {
    queryParams.append('limit', limit);
  }
  const response = await fetch(
    `${recoApiUrl()}/api/v1/promotional-products${queryParams ? `?${queryParams}` : ''}`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch promotional products', {
      categoryId,
      response
    });
  }
  return response.json();
};

export const usePromotionalProducts = (options = {}) => {
  const {categoryId = 218, limit = 20} = options?.queryParams || {};
  return useQuery({
    queryFn: () => fetchPromotionalProducts({categoryId, limit}),
    queryKey: ['promotional-products', categoryId, limit],
    ...options
  });
};

export default useRecommendedStyles;
